import { RoleGetResult, useRepositoryMutation } from '@mews-commander/data-access';
import { showSuccessAlert, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

export const useDeleteRole = () =>
    useRepositoryMutation('roles', 'delete', {
        transformParams: ({ role }: { role: RoleGetResult }) => ({ roleIds: [role.id] }),
        onSuccess: (_, { role }) => {
            showSuccessAlert({
                description: (
                    <LocalizedText textKey={TextKey.RoleDeleteSingleSuccess} substitutes={{ roleName: role.name }} />
                ),
            });
        },
        invalidateQueries: { roles: ['getAll'] },
    });

export const useDeleteRoles = () =>
    useRepositoryMutation('roles', 'delete', {
        onSuccess: (_, { roleIds }) => {
            showSuccessAlert({
                description: (
                    <LocalizedText textKey={TextKey.RoleDeleteMultiSuccess} substitutes={{ count: roleIds.length }} />
                ),
            });
        },
        invalidateQueries: { roles: ['getAll'] },
    });
